import {
  GET_BIRTHDAY_INFO,
  SET_BIRTHDAY_INFO,
  GET_NEW_COLABORATORS_INFO,
  SET_NEW_COLABORATORS_INFO,
  GET_PROFILE_DATA,
  SET_PROFILE_DATA,
  UPDATE_PROFILE_DATA,
  SET_UPDATE_PROFILE_DATA,
} from "./actionTypes";

const initialState = {
  isLoadingBirthday: false,
  isLoadingProfileData: false,
  isLoadingNewColaborators: false,
  birthdayInfo: [],
  colaboratorsInfo: [],
  profileData: {},
  setUpdateProfileData: false,
};

export function colaboratorProfileReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BIRTHDAY_INFO:
      return {
        ...state,
        isLoadingBirthday: true,
      };
    case SET_BIRTHDAY_INFO:
      return {
        ...state,
        isLoadingBirthday: false,
        birthdayInfo: action.data,
      };
    case GET_NEW_COLABORATORS_INFO:
      return {
        ...state,
        isLoadingNewColaborators: true,
      };
    case SET_NEW_COLABORATORS_INFO:
      return {
        ...state,
        isLoadingNewColaborators: false,
        colaboratorsInfo: action.data,
      };
    case GET_PROFILE_DATA:
      return {
        ...state,
        isLoadingProfileData: true,
      };
    case SET_PROFILE_DATA:
      return {
        ...state,
        isLoadingProfileData: false,
        profileData: action.data,
      };
    case UPDATE_PROFILE_DATA:
      return {
        ...state,
        setUpdateProfileData: true,
      };
    case SET_UPDATE_PROFILE_DATA:
      return {
        ...state,
        setUpdateProfileData: false,
        profileData: action.data,
      };
    default:
      return state;
  }
}
